import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import Container from '../container';
import SystemEntriesExplainer from './SystemEntriesExplainer';
import Button from '../button';
import parseStoryblokLink from '../../utils/parse-storyblok-link';
import ProductSlider from '../product-slider/ProductSlider';
import RichtextParser from '../../utils/richtext-parser';
import { styledLink } from '../../utils/styles';
import mq from '../../utils/mq';

const ProductsAndSystemsSectionOuterContainer = styled.div`
  background: var(--Color-Grey-05, #f8f8f8);
  padding-top: 104px;
  padding-bottom: 104px;
  ${mq.mobile(css`
    padding-top: 64px;
    padding-bottom: 64px;
  `)};
`;

const TopContentContainer = styled(Container)`
  ${mq.mobile(css`
    padding-bottom: 40px;
  `)};
`;

const TitleGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 20px;
`;

const TitleContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 80px;
  align-items: center;
  grid-column: 3 / span 8;
  ${mq.mobile(css`
    grid-column: 1 / span 12;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    gap: 16px;
    padding-bottom: 20px;
  `)};
`;

const Title = styled.h2`
  color: #161616;
  font-size: 42px;
  font-style: normal;
  font-weight: 700;
  line-height: 115%;
  letter-spacing: -0.84px;
  text-align: inherit;
  ${mq.mobile(css`
    font-size: 36px;
  `)};
`;

const Description = styled.div`
  color: var(--Foreground-fg-secondary, #565656);
  text-align: inherit;
  font-size: 18px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.36px;
  text-align: center;
  ${mq.mobile(css`
    text-align: left;
  `)};
  a {
    ${styledLink};
    text-decoration: none;
  }
`;

const CtaContainer = styled.div`
  width: fit-content;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 64px;
  ${mq.mobile(css`
    margin-top: 32px;
  `)};
`;

export default function ProductsAndSystemsSection({
  sectionTitle,
  sectionDescription,
  systemEntries
}: {
  sectionTitle: string;
  sectionDescription: string;
  systemEntries: any[];
}) {
  const [activeSystemEntry, setActiveSystemEntry] = useState<number>(0);
  return (
    <ProductsAndSystemsSectionOuterContainer>
      <TopContentContainer>
        <TitleGridContainer>
          <TitleContent>
            <Title>{sectionTitle}</Title>
            <Description
              dangerouslySetInnerHTML={{
                __html: RichtextParser(sectionDescription)
              }}
            />
          </TitleContent>
        </TitleGridContainer>
        <SystemEntriesExplainer
          systemEntries={systemEntries}
          activeSystemEntry={activeSystemEntry}
          setActiveSystemEntry={setActiveSystemEntry}
        />
      </TopContentContainer>
      <ProductSlider
        title={systemEntries[activeSystemEntry]?.systemProductSliderTitle}
        products={systemEntries[activeSystemEntry]?.systemProductSliderItems}
      />

      <Container>
        <CtaContainer>
          <Button
            to={parseStoryblokLink(
              systemEntries[activeSystemEntry]?.productSliderCtaLink
            )}
          >
            {systemEntries[activeSystemEntry]?.productSliderCtaLabel}
          </Button>
        </CtaContainer>
      </Container>
    </ProductsAndSystemsSectionOuterContainer>
  );
}
